<template>
  <EOL :lgSize="12" :lgOffset="0" :locParam="1" :idCity="0"></EOL>
</template>

<script>
import EOL from "../../components/EOL-Stacked";

import { Chart } from "highcharts-vue";
import router from "../../router";
import { allowedPath } from "../../shared/utils";

export default {
  name: "dashboard",
  components: {
    EOL,
    highcharts: Chart
  },
  mounted() {
    allowedPath(
      router.currentRoute.path,
      localStorage.getItem("user_tabs"),
      localStorage.getItem("redirect_path")
    );
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
